import { render, staticRenderFns } from "./IconPro.vue?vue&type=template&id=631745e8&scoped=true"
import script from "./IconPro.vue?vue&type=script&lang=js"
export * from "./IconPro.vue?vue&type=script&lang=js"
import style0 from "./IconPro.vue?vue&type=style&index=0&id=631745e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631745e8",
  null
  
)

export default component.exports